import {useQuery, UseQueryOptions, UseQueryResult} from '@tanstack/react-query'
import {httpGetEventsCount, HttpGetEventsCountResponse, HttpGetEventsCountOptions} from '../http/agenda.http'
import {QUERY_KEYS} from '@/queryClient'

export const useGetAgendaEventsCount = (
    params: HttpGetEventsCountOptions['params'],
    options?: Omit<UseQueryOptions<HttpGetEventsCountResponse, Error>, 'queryKey' | 'queryFn'>
): UseQueryResult<HttpGetEventsCountResponse, Error> => {
    return useQuery({
        queryKey: [QUERY_KEYS.AGENDA_EVENTS_COUNT, params],
        queryFn: () => httpGetEventsCount({params}),
        ...options
    })
}
